module.exports = {
	"title": "CSS3 2D Transforms",
	"description": "Method of transforming an element including rotating, scaling, etc. Includes support for `transform` as well as `transform-origin` properties.",
	"spec": "http://www.w3.org/TR/css3-2d-transforms/",
	"status": "wd",
	"links": [
		{
			"url": "http://www.westciv.com/tools/transforms/",
			"title": "Live editor"
		},
		{
			"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/transform",
			"title": "MDN article"
		},
		{
			"url": "http://www.webresourcesdepot.com/cross-browser-css-transforms-csssandpaper/",
			"title": "Workaround script for IE"
		},
		{
			"url": "http://www.css3files.com/transform/",
			"title": "Information page"
		},
		{
			"url": "http://www.useragentman.com/IETransformsTranslator/",
			"title": "Converter for IE"
		},
		{
			"url": "https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform",
			"title": "has.js test"
		},
		{
			"url": "http://docs.webplatform.org/wiki/css/transforms/transform",
			"title": "WebPlatform Docs"
		}
	],
	"bugs": [
		{
			"description": "Scaling transforms in Android 2.3 fails to scale element background images."
		},
		{
			"description": "IE 10 and below does not support CSS transforms on SVG elements (though SVG transform attributes do work)."
		},
		{
			"description": "In IE9 the caret of a `textarea` disappears when you use translate."
		},
		{
			"description": "Firefox 42 and below do not support [`transform-origin` on SVG elements](https://bugzilla.mozilla.org/show_bug.cgi?id=923193). "
		}
	],
	"categories": [
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "p",
			"7": "p",
			"8": "p",
			"9": "y x",
			"10": "y",
			"11": "y",
			"5.5": "n"
		},
		"edge": {
			"12": "y",
			"13": "y",
			"14": "y"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "y x",
			"5": "y x",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"11": "y x",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y",
			"17": "y",
			"18": "y",
			"19": "y",
			"20": "y",
			"21": "y",
			"22": "y",
			"23": "y",
			"24": "y",
			"25": "y",
			"26": "y",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"3.5": "y x",
			"3.6": "y x"
		},
		"chrome": {
			"4": "y x",
			"5": "y x",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"11": "y x",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y x",
			"27": "y x",
			"28": "y x",
			"29": "y x",
			"30": "y x",
			"31": "y x",
			"32": "y x",
			"33": "y x",
			"34": "y x",
			"35": "y x",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"54": "y",
			"55": "y",
			"56": "y",
			"57": "y"
		},
		"safari": {
			"4": "y x",
			"5": "y x",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y",
			"10": "y",
			"3.1": "y x",
			"3.2": "y x",
			"5.1": "y x",
			"6.1": "y x",
			"7.1": "y x",
			"9.1": "y",
			"TP": "y"
		},
		"opera": {
			"9": "n",
			"11": "y x",
			"12": "y x",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y",
			"24": "y",
			"25": "y",
			"26": "y",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "y x",
			"10.6": "y x",
			"11.1": "y x",
			"11.5": "y x",
			"11.6": "y x",
			"12.1": "y"
		},
		"ios_saf": {
			"8": "y x",
			"10": "y",
			"3.2": "y x",
			"4.0-4.1": "y x",
			"4.2-4.3": "y x",
			"5.0-5.1": "y x",
			"6.0-6.1": "y x",
			"7.0-7.1": "y x",
			"8.1-8.4": "y x",
			"9.0-9.2": "y",
			"9.3": "y"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "y x",
			"4": "y x",
			"53": "y",
			"2.1": "y x",
			"2.2": "y x",
			"2.3": "y x",
			"4.1": "y x",
			"4.2-4.3": "y x",
			"4.4": "y x",
			"4.4.3-4.4.4": "y x"
		},
		"bb": {
			"7": "y x",
			"10": "y x"
		},
		"op_mob": {
			"10": "n",
			"11": "y",
			"12": "y",
			"37": "y",
			"11.1": "y",
			"11.5": "y",
			"12.1": "y"
		},
		"and_chr": {
			"53": "y"
		},
		"and_ff": {
			"49": "y"
		},
		"ie_mob": {
			"10": "y",
			"11": "y"
		},
		"and_uc": {
			"11": "y x"
		},
		"samsung": {
			"4": "y"
		}
	},
	"notes": "The scale transform can be emulated in IE < 9 using Microsoft's \"zoom\" extension, others are (not easily) possible using the MS Matrix filter",
	"notes_by_num": {},
	"usage_perc_y": 93.34,
	"usage_perc_a": 0,
	"ucprefix": false,
	"parent": "",
	"keywords": "transformation,translate,translatex,translatey,translatez,transform3d,rotation,rotate,scale,css-transforms,transform-origin,transform:rotate,transform:scale",
	"ie_id": "transforms",
	"chrome_id": "6437640580628480",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/transforms2d.json
 ** module id = 452
 ** module chunks = 0
 **/